// store/user.js
function getUserInfoFromStorage() {
    const str = localStorage.getItem('userInfo');
    if (!str) return null;
    try {
        return JSON.parse(str);
    } catch (e) {
        // 解析失败，说明数据被污染，清理掉
        localStorage.removeItem('userInfo');
        return null;
    }
}

function getPermissionsFromStorage() {
    const str = localStorage.getItem('permissions');
    if (!str) return [];
    try {
        return JSON.parse(str);
    } catch (e) {
        localStorage.removeItem('permissions');
        return [];
    }
}

const state = {
    userInfo: getUserInfoFromStorage(),
    token: localStorage.getItem('molv_token') || '',
    expiresIn: localStorage.getItem('expiresIn') || '',
    permissions: getPermissionsFromStorage(),
};


const mutations = {
    SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo;
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    SET_TOKEN(state, token) {
        state.token = token;
        localStorage.setItem('molv_token', token);
    },
    SET_EXPIRES_IN(state, expiresIn) {
        state.expiresIn = expiresIn;
        localStorage.setItem('expiresIn', expiresIn);
    },
    SET_PERMISSIONS(state, permissions) {
        state.permissions = permissions || [];
        localStorage.setItem('permissions', JSON.stringify(state.permissions));
    },
    CLEAR_USER(state) {
        state.userInfo = null;
        state.token = '';
        state.expiresIn = '';
        state.permissions = [];
        localStorage.removeItem('userInfo');
        localStorage.removeItem('molv_token');
        localStorage.removeItem('expiresIn');
        localStorage.removeItem('permissions');
    }
};

const actions = {
    saveUserInfo({ commit }, { userInfo, molv_token, expiresIn }) {
        commit('SET_USER_INFO', userInfo);
        commit('SET_TOKEN', molv_token);
        commit('SET_EXPIRES_IN', expiresIn);
        // 从 userInfo 中提取权限码
        const perms = (userInfo && userInfo.permissions) || [];
        commit('SET_PERMISSIONS', perms);
    },
    logout({ commit }) {
        commit('CLEAR_USER');
    }
};

const getters = {
    userInfo: state => state.userInfo,
    token: state => state.token,
    expiresIn: state => state.expiresIn,
    permissions: state => state.permissions,
    hasPermission: state => (code) => {
        if (!code) return true;
        const perms = state.permissions || [];

        const userInfo = state.userInfo || {};
        const role = userInfo.sys_admin ? userInfo.sys_admin.role : null;

        // 超级管理员/总公司管理员自动拥有所有权限
        if ([1, 4].includes(role)) return true;

        return perms.includes(code);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
